var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17595 12.1005C4.58378 14.0127 7.51143 17.1719 12.0008 17.1719C16.4902 17.1719 19.4179 14.0127 20.8257 12.1005C19.2379 9.95077 16.5098 6.67188 12.0008 6.67188C7.49181 6.67188 4.76373 9.95077 3.17595 12.1005ZM1.66473 11.6257C3.16028 9.567 6.35317 5.17188 12.0008 5.17188C17.6485 5.17188 20.8414 9.567 22.3369 11.6257L22.6701 12.0843L22.3677 12.5216C21.0725 14.3943 17.6529 18.6719 12.0008 18.6719C6.34879 18.6719 2.92914 14.3943 1.63397 12.5216L1.33154 12.0843L1.66473 11.6257Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0015 14.1719C13.2441 14.1719 14.2515 13.1645 14.2515 11.9219C14.2515 10.6792 13.2441 9.67188 12.0015 9.67188C10.7588 9.67188 9.75146 10.6792 9.75146 11.9219C9.75146 13.1645 10.7588 14.1719 12.0015 14.1719ZM12.0015 15.6719C14.0725 15.6719 15.7515 13.9929 15.7515 11.9219C15.7515 9.85081 14.0725 8.17188 12.0015 8.17188C9.9304 8.17188 8.25146 9.85081 8.25146 11.9219C8.25146 13.9929 9.9304 15.6719 12.0015 15.6719Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.5280e9dc8c8087fbd9eb6fd42d72757f.svg";
export { ForwardRef as ReactComponent };